<template>
    <AddPupils callerRole="teacher" :pupils="pupils" :classes="classes" :addUsers="addUsers" />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ParsedUser } from '@ilteducation/giglets-types';

definePage({ meta: { area: 'pupils-and-groups' } });
const store = useTeacherStore();
store.fetchClasses();
store.fetchPupils();

const { pupils, classes } = storeToRefs(store);

const addUsers = async (_type: 'pupil' | 'teacher', users: ParsedUser[]) => {
    await store.addPupils(users);
};
</script>
